module.exports = __webpack_public_path__ + "img/u380.eec40bdf.png";